module.exports = __webpack_public_path__ + "img/25_23.74a89f9e.png";